import listaDepositos from "../../Finanzas/Pages/listaDepositos";

export default [
  {
    title: "Compras",
    icon: "entypo entypo-basket",
    perms: ["ADMIN", "COMPRAS"],
    subModulos: [
      {
        subtitulo: "Orden de compra",
        ruta: { name: "ordenCompra" },
      },
      {
        subtitulo: "Listar Compras",
        ruta: { name: "listar" },
      },
      {
        subtitulo: "Proveedores",
        ruta: { name: "proveedores" },
      },
      {
        subtitulo: "Transporte",
        ruta: { name: "transporte" },
      },
      {
        subtitulo: "Productos",
        ruta: { name: "productos" },
      },
      {
        subtitulo: "Sugerido compra",
        ruta: { name: "sugerido-compra" },
      },
      {
        subtitulo: "Sugerido compra V2",
        ruta: { name: "sugerido-compraV2" },
      },
    ],
  },
  {
    title: "Productos",
    icon: "entypo entypo-archive",
    perms: ["ADMIN", "RECEPCION"],
    subModulos: [
      {
        subtitulo: "Producto",
        ruta: { name: "producto" },
      },
      {
        subtitulo: "Listar Productos",
        ruta: { name: "listarProductoMiranda" },
      },
      {
        subtitulo: "Nuevo Listar Productos",
        ruta: { name: "newListProducts" },
      },
      {
        subtitulo: "Categoria",
        ruta: { name: "categoriaProducto" },
      },
      {
        subtitulo: "Familia Producto",
        ruta: { name: "familiaProducto" },
      },
      {
        subtitulo: "Clasificación Producto",
        ruta: { name: "clasificacionProducto" },
      },
      {
        subtitulo: "Marca Producto",
        ruta: { name: "marcaProducto" },
      },
      {
        subtitulo: "Vehiculos",
        ruta: { name: "vehiculos" },
      },
      {
        subtitulo: "Marca Vehiculos",
        ruta: { name: "marcas" },
      },
      {
        subtitulo: "Modelo Vehiculo",
        ruta: { name: "modelo" },
      },
    ],
  },
  {
    title: "Asociación",
    icon: "fa fa-chain",
    perms: ["ADMIN", "RECEPCION"],
    subModulos: [
      {
        subtitulo: "Asociación",
        ruta: { name: "asociacion" },
      },
    ],
  },
  {
    title: "Recepción",
    icon: "fa fa-handshake-o",
    perms: ["ADMIN", "RECEPCION", "RECEPCION_GUIA"],
    subModulos: [
      {
        subtitulo: "Nueva Recepción",
        ruta: { name: "recepcion" },
      },
      {
        subtitulo: "Listar Documentos",
        ruta: { name: "documento" },
      },
      {
        subtitulo: "Listar Documentos V2",
        ruta: { name: "listarDocumentosV2" },
      },
      {
        subtitulo: "Productos Pendientes",
        ruta: { name: "productoPendiente" },
      },
      {
        subtitulo: "Guia Traslado",
        ruta: { name: "recepcionGuia" },
      },
      /*       {
        subtitulo: "Nuevo Guía Traslado",
        ruta: { name: "newTransferGuide" },
      }, */
      {
        subtitulo: "Mantenedor-Ubicaciones",
        ruta: { name: "newLocationMaintainer" },
      },
      /*       {
        subtitulo: "Nuevo Documentos",
        ruta: { name: "newDocuments" },
      }, */
      {
        subtitulo: "Reportes",
        ruta: { name: "reporteRecepcionKibana" },
      },
    ],
  },
  {
    title: "Marketing",
    icon: "vuestic-icon vuestic-icon-statistics",
    perms: ["ADMIN", "MARKETING"],
    subModulos: [
      {
        subtitulo: "Factor Categoria",
        ruta: { name: "categoria" },
      },
      {
        subtitulo: "Factor Familia",
        ruta: { name: "familia" },
      },
      {
        subtitulo: "Precios",
        ruta: { name: "precios" },
      },
      {
        subtitulo: "Ofertas",
        ruta: { name: "ofertas" },
      },
      // {
      //   subtitulo: 'Reportes',
      //   ruta: {name: 'reporteMarketing'}
      // }
    ],
  },
  {
    title: "Finanzas",
    icon: "fa fa-dollar",
    perms: ["ADMIN", "FINANZAS"],
    subModulos: [
      {
        subtitulo: "Cheques",
        ruta: { name: "cheques" },
      },
      {
        subtitulo: "Convenio Clientes",
        ruta: { name: "convenioClientes" },
      },
      {
        subtitulo: "Clientes Crédito",
        ruta: { name: "clientesCredito" },
      },
      {
        subtitulo: "Clientes Crédito V2",
        ruta: { name: "clientesCreditoV2" },
      },
      {
        subtitulo: "Proveedores",
        ruta: { name: "finanzasListaProveedores" },
      },
      {
        subtitulo: "Notas de Credito",
        ruta: { name: "notasCredito" },
      },
      {
        subtitulo: "Costo de Ventas",
        ruta: { name: "costoVentas" },
      },
      {
        subtitulo: "Listado Depositos",
        ruta: { name: "listaDepositos" },
      },
      {
        subtitulo: "Consolidado Por Periodo",
        ruta: { name: "consolidadoPeriodo" },
      },
      {
        subtitulo: "Cierre Periodo",
        ruta: { name: "ventasAnual" },
      },
      {
        subtitulo: "Presupuesto",
        ruta: { name: "presupuesto" },
      },
      {
        subtitulo: "Costos",
        ruta: { name: "newCosts" },
      },
      {
        subtitulo: "Dépositos",
        ruta: { name: "newDeposit" },
      },
      /* News */
      /* Gráficos */
      {
        subtitulo: "Gráficos",
        ruta: { name: "newCharts" },
      },
      /* Metas */
      {
        subtitulo: "Metas",
        ruta: { name: "newGoals" },
      },
      /* Clientes Crédito" */
      /*       {
        subtitulo: "Nuevo Clientes Crédito",
        ruta: { name: "newCreditClients" },
      }, */
    ],
  },
  {
    title: "Sucursales",
    icon: "entypo entypo-address",
    perms: ["ADMIN"],
    subModulos: [
      {
        subtitulo: "Crear Sucursales",
        ruta: { name: "sucursales" },
      },
      {
        subtitulo: "Generar Inventario",
        ruta: { name: "appInventario" },
      },
    ],
  },
  {
    title: "Ventas",
    icon: "entypo entypo-basket",
    perms: ["ADMIN", "VENTAS"],
    subModulos: [
      {
        subtitulo: "Nueva Venta",
        ruta: { name: "nueva" },
      },
      {
        subtitulo: "Listar Ventas",
        ruta: { name: "listarVentas" },
      },
      {
        subtitulo: "Historico DTE",
        ruta: { name: "historico-dte" },
      },
      {
        subtitulo: "Listar Ventas V2",
        ruta: { name: "listarVentasV2" },
      },
      {
        subtitulo: "Venta V2",
        ruta: { name: "ventaV2" },
      },
      {
        subtitulo: "Despacho",
        ruta: { name: "despacho" },
      },
      // {
      //   subtitulo: 'Reportes',
      //   ruta: {name: 'indexReportes'}
      // }
    ],
  },
  // {
  //   title: "Picking",
  //   icon: "fa fa-envelope-open-o",
  //   perms: ["ADMIN", "PICKING", "BODEGA"],
  //   subModulos: [
  //     {
  //       subtitulo: "Picking",
  //       ruta: {name: "listarPicking"}
  //     },
  //     {
  //       subtitulo: "Re Ingreso Bodega",
  //       ruta: {name: "reIngresoBodega"}
  //     }
  //   ]
  // },
  {
    title: "Caja",
    icon: "entypo entypo-credit-card",
    perms: ["ADMIN", "CAJA"],
    subModulos: [
/*       {
        subtitulo: "Caja",
        ruta: { name: "caja" },
      }, */
/*       {
        subtitulo: "Historico",
        ruta: { name: "historico" },
      }, */
/*       {
        subtitulo: "Retiro Caja",
        ruta: { name: "retiroCaja" },
      }, */
      {
        subtitulo: "Rendicion",
        ruta: { name: "rendicion" },
      },
/*       {
        subtitulo: "Ingresos",
        ruta: { name: "ingresos" },
      }, */
/*       {
        subtitulo: "Egresos",
        ruta: { name: "egresos" },
      }, */
      //new cash Register
      {
        subtitulo: "Nueva Caja",
        ruta: { name: "nueva-caja" },
      },
      {
        subtitulo: "Nuevo Histórico Dte",
        ruta: { name: "nuevo-historico-dte" },
      },
      {
        subtitulo: "Nueva Rendición",
        ruta: { name: "nueva-rendicion" },
      },
      {
        subtitulo: "Nuevo Retiro",
        ruta: { name: "nuevo-retiro" },
      },
      {
        subtitulo: "Nuevo Ingreso",
        ruta: { name: "nuevo-ingreso" },
      },
      {
        subtitulo: "Nuevo Egreso",
        ruta: { name: "nuevo-egreso" },
      },
      {
        subtitulo: "Nuevo Saldo a Favor",
        ruta: { name: "nuevo-saldo-favor" },
      },
      {
        subtitulo: "Nuevo Encargo Histórico",
        ruta: { name: "nuevo-encargo" },
      },
    ],
  },
  {
    title: "Usuarios",
    icon: "fa fa-user",
    perms: ["ADMIN"],
    subModulos: [
      {
        subtitulo: "Usuarios",
        ruta: { name: "listarUsuarios" },
      },
    ],
  },
  {
    title: "Devoluciones",
    icon: "fa fa-undo",
    perms: ["ADMIN", "RECEPCION"],
    subModulos: [
      {
        subtitulo: "Devoluciones",
        ruta: { name: "devoluciones" },
      },
      {
        subtitulo: "Generar Devolución",
        ruta: { name: "generarDevolucion" },
      },
      {
        subtitulo: "Devoluciónes Generadas",
        ruta: { name: "devolucionesGeneradas" },
      },
    ],
  },
  {
    title: "Bodega",
    icon: "fa fa-home",
    perms: ["ADMIN", "BODEGA"],
    subModulos: [
      {
        subtitulo: "Pedidos",
        ruta: { name: "generarGuias" },
      },
      {
        subtitulo: "Generar Guia",
        ruta: { name: "pedidoEntreSucursales" },
      },
      /*       {
        subtitulo: "Nuevo Generar Guía",
        ruta: { name: "newGuideGeneratorV4" },
      }, */
      {
        subtitulo: "Ver Guias Generadas",
        ruta: { name: "guiasTraslado" },
      },
      {
        subtitulo: "Ajuste Stock",
        ruta: { name: "ajusteStock" },
      },
      {
        subtitulo: "Reportes Productos",
        ruta: { name: "reportesProductos" },
      },
      {
        subtitulo: "Inventario Sucursal",
        ruta: { name: "inventarioSucursal" },
      },
      {
        subtitulo: "Inventario",
        ruta: { name: "inventario" },
      },
      {
        subtitulo: "Registro Ubicaciones",
        ruta: { name: "registroUbicaciones" },
      },
      {
        subtitulo: "Mapeo Bodega",
        ruta: { name: "mapeoBodega" },
      },
      {
        subtitulo: "Despacho-Empaque",
        ruta: { name: "empaque-despacho" },
      },
      {
        subtitulo: "Autorización NC",
        ruta: { name: "credit-memo/list" },
      },
      {
        subtitulo: "Nuevo Inventario Sucursal",
        ruta: { name: "new-inventory-branchV4" },
      },
      {
        subtitulo: "Nuevo Inventario",
        ruta: { name: "new-inventoryV4" },
      },
    ],
  },
  {
    title: "Post Venta",
    icon: "fa fa-dollar",
    perms: ["ADMIN", "POSTVENTA"],
    subModulos: [
      /*       {
        subtitulo: "Post Venta",
        ruta: { name: "devolucionCliente" },
      }, */
      {
        subtitulo: "Posventa",
        ruta: { name: "posventa" },
      },
      {
        subtitulo: "Posventa Nuevo Dte",
        ruta: { name: "posventaNewDte" },
      },
      /*       {
        subtitulo: "Posventa V3",
        ruta: { name: "newPosventaV4" },
      }, */
      {
        subtitulo: "Historico",
        ruta: { name: "historicoCliente" },
      },
    ],
  },
  {
    title: "Empaque",
    icon: "fa fa-chain",
    perms: ["ADMIN", "EMPAQUE", "CAJA"],
    subModulos: [
      {
        subtitulo: "Empaque",
        ruta: { name: "empaque" },
      },
      {
        subtitulo: "Vouchers",
        ruta: { name: "vouchers" },
      },
    ],
  },
  {
    title: "Informática",
    icon: "fa fa-desktop",
    perms: ["ADMIN"],
    subModulos: [
      {
        subtitulo: "Solicitud Requerimientos",
        ruta: { name: "solicitudRequerimientos" },
      },
      {
        subtitulo: "Mesa de Ayuda",
        ruta: { name: "solicitud-ayuda" },
      },
      {
        subtitulo: "Administrar Helpdesk",
        ruta: { name: "administrar-solicitudes" },
      },
    ],
  },
  {
    title: "Documentación",
    icon: "fa fa-book",
    perms: [
      "ADMIN",
      /*       "COMPRAS",
      "PRODUCTO",
      "BODEGA",
      "RECEPCION",
      "MARKETING",
      "FINANZAS",
      "VENTAS",
      "CAJA",
      "EMPAQUE", */
      "RRHH",
    ],
    subModulos: [
      {
        subtitulo: "Ver Documentos",
        ruta: { name: "viewDocuments" },
      },
      {
        subtitulo: "Subir Documentos",
        ruta: { name: "uploadDocuments" },
      },
    ],
  },
  {
    title: "Recursos Humanos",
    icon: "fa fa-user",
    perms: ["ADMIN", "RRHH"],
    subModulos: [
      {
        subtitulo: "Trabajadores",
        ruta: { name: "trabajadores" },
      },
      {
        subtitulo: "Cargos",
        ruta: { name: "admin-cargos" },
      },
      {
        subtitulo: "Comisiones v2",
        ruta: { name: "mantenedor-comisiones" },
      },
      {
        subtitulo: "Periodo Comisiones v2",
        ruta: { name: "periodo-comisiones" },
      },
      {
        subtitulo: "Comisiones",
        ruta: { name: "comisiones" },
      },
      {
        subtitulo: "Asistencia",
        ruta: { name: "asistencia" },
      },
      {
        subtitulo: "Vacaciones",
        ruta: { name: "admin-vacaciones" },
      },
      {
        subtitulo: "Usuarios",
        ruta: { name: "usuarios" },
      },
      /*{
        subtitulo: 'Trabajadores',
        ruta: {name: 'rrhh-trabajadores'}
      },
      {
        subtitulo: 'Ingresar trabajador',
        ruta: {name: 'rrhh-ingresar-trabajador'}
      }*/
    ],
  },
  {
    title: "Clientes",
    icon: "fa fa-drivers-license",
    perms: ["ADMIN", "FINANZAS"],
    subModulos: [
      {
        subtitulo: "Historico Cliente",
        ruta: { name: "HistoricoCliente" },
      },
    ],
  },
  {
    title: "Reportes",
    icon: "fa fa-calendar",
    perms: ["ADMIN", "REPORTE_RESUMEN_VENTA"],
    subModulos: [
      {
        subtitulo: "Reportes",
        ruta: { name: "main" },
      },
    ],
  },
  {
    title: "Permiso de Ventas",
    icon: "fa fa-key",
    perms: ["ADMIN"], //, "POSTVENTA"
    subModulos: [
      {
        subtitulo: "Solicitudes",
        ruta: { name: "solicitudes" },
      },
    ],
  },
  {
    title: "Asesorías",
    icon: "fa fa-desktop",
    perms: [
      "ADMIN",
      "RRHH",
      "FINANZAS",
      "MARKETING",
      "ASESORIA",
      "PARITARIO",
      "PREVENCION",
    ],
    subModulos: [
      {
        subtitulo: "EPP Acuerdos",
        ruta: { name: "epp-acuerdos" },
      },
      {
        subtitulo: "EPP Management",
        ruta: { name: "epp-management" },
      },
    ],
  },
];
